export default __webpack_public_path__ + "static/media/Diana_Melison.d6bca3c9.png";